export default __webpack_public_path__ + "static/media/scardor-logo.f42ae905.png";